import styled from "styled-components";
import { Button, Modal } from "antd";

export const EstoqueButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: #0f766e !important;
  border-color: #0f766e !important;
  color: #fff !important;
  border-radius: 10px !important;

  &:hover,
  &:focus {
    background-color: #0d9488 !important;
    border-color: #0d9488 !important;
    color: #fff !important;
  }
`;

export const BadgeCount = styled.span`
  background: #e53935;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  border-radius: 50%;
  min-width: 22px;
  width: 22px;
  height: 22px;
  /* Ant Design .ant-btn > span { display: inline-block } sobrescreve sem !important */
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin-left: 4px;
  line-height: 1;
  flex-shrink: 0;
  text-align: center;
  box-sizing: border-box;
  box-shadow: 0 0 0 2px #0f766e;
`;

export const StyledEstoqueModal = styled(Modal)`
  .ant-modal-header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #12619c;
    height: 61px;
  }

  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-modal-body {
    padding: 16px 20px;
    max-height: calc(90vh - 140px);
    overflow-y: auto;
  }

  .ant-modal-title {
    color: #fff;
    font-weight: bold;
  }

  .ant-modal-close-x {
    color: #fff;
  }

  .ant-modal-footer {
    border-top: 1px solid #e0e0e0;
  }

  /* && sobe especificidade o bastante p/ vencer o Ant Table global (styles.scss) */
  && .ant-table-tbody > tr.ant-table-row.row-alerta > td {
    background: #fff2f0 !important;
  }

  && .ant-table-tbody > tr.ant-table-row.row-alerta:hover > td {
    background: #ffe7e3 !important;
  }

  .prev-negativa {
    color: #e53935 !important;
    font-weight: 700;
  }

  .insumo-cell {
    white-space: nowrap;
    min-width: 320px;
  }
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ButtonStyledLink = styled(Button)`
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;

  &:hover,
  &:active,
  &:focus {
    color: #666;
    border: 1px solid #ddd;
    background-color: #e9ecef !important;
  }
`;
